import { useMemo, useCallback } from 'react';
import _escapeRegExp from 'lodash/escapeRegExp';

import { SelectProps } from '../Select';
import { SelectOptionType } from '../types';

export default function useShownOptions<T extends SelectOptionType>(
  filterOption: SelectProps<T>['filterOption'],
  parsedOptions: T[],
  searchValue: string,
  minSearchChars: number,
) {
  const getFilterOptions = useCallback(() => {
    const options = parsedOptions.filter((option) => !option.hidden);

    if (!filterOption) return options;

    if (filterOption === true) {
      if (searchValue.length === 0) return options;
      if (searchValue.length < minSearchChars) return [];

      const filteredOptions = options.filter((option) => {
        const reg = new RegExp(_escapeRegExp(searchValue), 'i');
        return reg.test(option.label);
      });

      return filteredOptions;
    } else {
      return options.filter((option) => filterOption(searchValue, option));
    }
  }, [filterOption, minSearchChars, parsedOptions, searchValue]);

  return useMemo(() => {
    return getFilterOptions();
  }, [getFilterOptions]);
}
